module.exports = __webpack_public_path__ + "img/ch16_04_深巷带路.961b4ea6.jpg";